import { IAutomationBlueprint } from './Automation';
import { AutomationTriggerType } from './AutomationTrigger';
import { IAutomationExecutionVariable } from './AutomationVariable';

export interface IAutomationWorkflowParams {
  clientId: string;
  executionId: string;
  blueprint: IAutomationBlueprint;
  triggerType: AutomationTriggerType;
  variables: IAutomationExecutionVariable[];
}
